import { createSlice } from '@reduxjs/toolkit';

export const UPSELL_TYPE = {
    PRE_ALIGNMENT_FIRST_Q14: 'PRE_ALIGNMENT_FIRST_Q14',
    ALIGN_FIRST_Q16: 'ALIGN_FIRST_Q16',
    ALIGN_AND_RESTORE_Q14_AND_Q16: 'ALIGN_AND_RESTORE_Q14_AND_Q16',
};

export const UPSELL_TYPES_SHOW_EXOCAD = [
    UPSELL_TYPE.ALIGN_FIRST_Q16,
    UPSELL_TYPE.ALIGN_AND_RESTORE_Q14_AND_Q16,
    UPSELL_TYPE.PRE_ALIGNMENT_FIRST_Q14,
];

export const UPSELL_TYPES_NEED_RESTORATION_FORM_WITHOUT_IMPRESSION = [];

const initialTpApprovalState = {
    planId: null,
    upsellRestorationFormData: null,
    upsellRestorationImpressionData: null,
    upsellType: null,
    shouldApproveUpsellPart: false,
    upgradeOption: null,
    defaultCaseTypeId: null,
    approvementOption: null,
};

// This slice for treatment plan approval related state management
export const treatmentPlanApprovalSlice = createSlice({
    name: 'treatmentPlanApproval',
    initialState: { ...initialTpApprovalState },
    reducers: {
        setUpsellType: (state, action) => {
            console.log('action => ', action);
            console.log('action.payload: ', action.payload);
            const { upsellType, shouldApproveUpsellPart } = action.payload;
            state.upsellType = upsellType;
            state.shouldApproveUpsellPart = shouldApproveUpsellPart;
        },
        setUpsellRestorationFormData: (state, action) => {
            state.upsellRestorationFormData = action.payload;
        },
        setUpsellPlanId: (state, action) => {
            console.log('action => ', action);
            console.log('action.payload: ', action.payload);
            state.planId = action.payload;
        },
        setUpgradeOption: (state, action) => {
            console.log('action => ', action);
            console.log('action.payload: ', action.payload);
            const { upgradeOption, defaultCaseTypeId } = action.payload;
            state.upgradeOption = upgradeOption;
            state.defaultCaseTypeId = defaultCaseTypeId;
        },
        setApprovementOption: (state, action) => {
            state.approvementOption = action.payload;
        },
    },
});

export const { setUpsellType, setUpsellRestorationFormData, setUpsellPlanId, setUpgradeOption, setApprovementOption } =
    treatmentPlanApprovalSlice.actions;

export default treatmentPlanApprovalSlice.reducer;
